import React, { Fragment, memo, useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getCookie, isLogin } from "../../modules/utils/cookie";

// Provider
import {
  AppContext,
  LOG_OUT_SUCCESS,
  MENU_SET_ALL,
  SET_APP_ALL,
  SET_GPSINFO2,
  SET_ITEMSTATE,
  SocketCommand,
  checkMobile,
  socketManager,
} from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";

// UI
import { IC } from "../../resources/Assets";
import { Container, DateLayer, closeLayerFn, openLayerFn } from "../Layout";

// Temp Images
// import _T_MEAL from "../../../resources/images/user/user_meal_photo01.jpg";

import { SUBS, SubMenu, TYPES_RECEIPT, TypeMenu } from "./Menu";

// Network
import {
  PostApi1910,
  PostApi1913,
  PostApi201,
  PostApi203,
  PostApi251,
  PostApi254,
  PostApi255,
  PostApi256,
  PostApi999,
} from "../../modules/network/padoPost";

// Map
import { MapView } from "../common/Modal/NaverMap";
// import { RenderAfterNavermapsLoaded, NaverMap, Marker } from "react-naver-maps";

import { sendFaxModule } from "../../modules/utils/SendFax";
import { reLogin } from "../common/AutoLogin/AutoLogin";

import { AlertLayer, ConfirmLayer } from "../../components/UI/Dialog";
import { GetGpsInfo } from "../../modules/utils/GetGpsInfo";
import { NativeAction } from "../../modules/utils/HandleWs";
import { userHabit } from "../../modules/utils/UserHabit";
import { commonFileUpload } from "../PersonalMedicalRecords/PmrLayout";
import { closeLoadingLayer } from "../common/Layer/Loading";
import SkeletonPharm from "../common/Skeleton/SkeletonPharm";
import useTitle from "../../modules/hooks/useTitle";

export default props => {
  useTitle("처방전_약국접수");
  const { auth, userinfo, cfg, phonecfg, dispatch, pageState, itemState } =
    useContext(AppContext);

  const sub = SUBS[0];
  const [typeIndex, setTypeIndex] = useState(0);
  const type = TYPES_RECEIPT[typeIndex];

  const [selectedEocsIndex, setSelectedEocsIndex] = useState(0);
  const [eocsList, setEocsList] = useState(null);
  const [pharmacyList, setPharmacyList] = useState(null);

  const [locationInfo, setLocationInfo] = useState({});

  const [loading, setLoading] = useState(true);

  const pxid = useRef("");
  const phKey = useRef("");
  const pxStatus = useRef("");

  // 지도
  const [maps, setMaps] = useState({
    name: "",
    latitude: userinfo.userLat,
    longitude: userinfo.userLng,
  });

  const handleMaps = (name, latitude, longitude) => {
    setMaps({
      name: name,
      latitude: latitude,
      longitude: longitude,
    });
  };

  // 처방전 다운로드 inifo
  const [eocsInfo, setEocsInfo] = useState({
    filePath: "",
    url: "",
    userToken: "",
    pxid: "",
    zipcode: "",
  });

  const handleEocsInfo = (filePath, url, userToken, pxid, zipcode) => {
    setEocsInfo({
      filePath: filePath,
      url: url,
      userToken: userToken,
      pxid: pxid,
      zipcode: zipcode,
    });
  };

  const [requestEocs, setRequestEocs] = useState(Date());

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
    handleConfirmCB: "",
  });

  const handleDialog = (title, msg, handleConfirmCB) => {
    setDialog({
      title: title,
      msg: msg,
      handleConfirmCB: handleConfirmCB,
    });

    if (handleConfirmCB == "certi") {
      openLayerFn($(".confirm-layer"));
    } else {
      openLayerFn($(".alert-layer"));
    }
  };
  // 다이얼로그 ]]

  const handleReceiptRequest = (param1, param2) => {
    if (eocsList === null) {
      handleDialog("", "조제할 처방전이 없습니다.", "");
      return;
    }

    phKey.current = param1;
    pxStatus.current = param2;

    if (param2 === "1") {
      openLayerFn($(".receive-alert-layer"));
    } else {
      openLayerFn($(".receive-inquiry-layer"));
    }
  };

  const putJsonData = (
    downType,
    fileName,
    downLink,
    userToken,
    pxId,
    zipCode,
    viewYN,
    reserved
  ) => {
    return {
      downType: downType,
      fileName: fileName,
      downLink: downLink,
      userToken: userToken,
      pxId: pxId,
      zipCode: zipCode,
      viewYN: viewYN,
      reserved: reserved,
    };
  };

  const request201 = () => {
    PostApi201(
      userinfo,
      cfg,
      phonecfg,
      pxid.current,
      phKey.current,
      pxStatus.current
    )
      .then(res => {
        if (res.resultCode === "000") {
          if (pxStatus.current === "1") {
            //확인 : 접수가 완료되었습니다. 열기
            openLayerFn($(".receive-complete-layer"));
            setRequestEocs(Date());
          } else {
            _O.Open("/eocs/history/0");
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const socketConnection = (trsmId, paperFlag) => {
    let masterKey2 = "E";

    commonFileUpload(
      reloadList,
      userinfo,
      trsmId + "!" + masterKey2,
      1,
      "N",
      "EP",
      "전자처방전",
      "10"
    );
  };

  const handleRequest201 = () => {
    // 처방전 다운로드 안했을때 다운로드 실행
    try {
      if (eocsInfo.filePath === "") {
        socketConnection(eocsInfo.pxid);
      }
    } catch (e) {
      handleDialog("", "단말기에서 처방전 다운로드 됩니다.", "");
    }

    PostApi201(
      userinfo,
      cfg,
      phonecfg,
      pxid.current,
      phKey.current,
      pxStatus.current
    )
      .then(res => {
        if (res.resultCode === "000") {
          if (pxStatus.current === "1") {
            //확인 : 접수가 완료되었습니다. 열기
            openLayerFn($(".receive-complete-layer"));
            setRequestEocs(Date());
          } else {
            _O.Open("/eocs/history/0");
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const request1910 = (userinfo, cardType) => {
    PostApi1910(userinfo, cfg, phonecfg, cardType)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          let data = res.result;

          if (data.length > 0)
            dispatch({ type: MENU_SET_ALL, menutype: cardType, data: data });
        } else if (res.resultMsg === "LOGOUT") {
          // handleDialog("", '다시 로그인하세요.')]
          openLayerFn($(".alert-layer-logout"));
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
  const request1913 = userinfo => {
    PostApi1913(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          let data = res.result;
          dispatch({ type: SET_APP_ALL, data: data });
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
  const handleRequest251 = () => {
    PostApi251(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultCode === "000" && res.resultList.length > 0) {
          setEocsList(res.resultList);

          let pxIdIndex = 0;

          const resultList = res.resultList;
          for (let i = 0; i < resultList.length; i++) {
            if (resultList[i].pxid === props.match.params.selectedPxID) {
              pxIdIndex = i;
              break;
            }
          }

          setSelectedEocsIndex(pxIdIndex);

          const eprescription = resultList[pxIdIndex];
          pxid.current = resultList[pxIdIndex].pxid;

          handleEocsInfo(
            eprescription.filePath === null ? "" : eprescription.filePath,
            eprescription.url === null ? "" : eprescription.url,
            userinfo.userToken,
            eprescription.pxid,
            eprescription.hospital[0].zipcode
          );
        } else {
          setEocsList(null);
        }
      })
      .catch(err => {
        console.log(err);
        setEocsList(null);
      });
  };

  const reloadList = () => {
    handleRequest251();
    closeLoadingLayer();
  };

  useEffect(() => {
    if (pageState.reload === 1) {
      reloadList();
    }
  }, [pageState.reload]);

  let userinfo2 = reLogin(auth, userinfo, dispatch);

  useEffect(() => {
    // if (getCookie("isAuthOk") == 0) {
    PostApi999(phonecfg, cfg, userinfo2.userToken)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.resultList === 1) {
            handleRequest251();
            if (!auth && isLogin()) {
              request1910(userinfo2, "");
              request1913(userinfo2);
            }
          } else {
            openLayerFn($(".alert-layer-logout"));
          }
        }
      })
      .catch(err => {});
  }, [requestEocs]);

  // MY 약국
  const handleRequest254 = () => {
    PostApi254(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultCode === "000" && res.resultList.length > 0) {
          setPharmacyList(res.resultList);
        } else if (res.resultCode === "999" && res.resultMsg === "LOGOUT") {
          openLayerFn($(".alert-layer-logout"));
          dispatch({ type: LOG_OUT_SUCCESS });
          socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
            login: "out",
            userToken: "",
          });
        } else {
          setPharmacyList([]);
        }
        setLoading(false);
      })
      .catch(err => {
        setPharmacyList([]);
        setLoading(false);
      });
  };

  // 주변 약국
  const handleRequest255 = () => {
    PostApi255(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultCode === "000" && res.resultList.length > 0) {
          setPharmacyList(res.resultList);
        } else {
          setPharmacyList([]);
        }
        setLoading(false);
      })
      .catch(err => {
        setPharmacyList([]);
        setLoading(false);
      });
  };

  // 약국 검색
  const handleRequest256 = (searchPharmacyName, searchAddres) => {
    PostApi256(userinfo, cfg, phonecfg, searchPharmacyName, searchAddres)
      .then(res => {
        if (res.resultCode === "000" && res.resultList.length > 0) {
          setPharmacyList(res.resultList);
        } else {
          setPharmacyList([]);
        }
        setLoading(false);
      })
      .catch(err => {
        setPharmacyList([]);
        setLoading(false);
      });
  };

  const handleSearchPharmacy = (keyword1, keyword2) => {
    if (keyword1.length > 0 && keyword2.length > 0) {
      handleRequest256(keyword1, keyword2);
    } else if (keyword1.length > 0) {
      handleRequest256(keyword1, "");
    } else if (keyword2.length > 0) {
      handleRequest256("", keyword2);
    }
  };

  useEffect(() => {
    if (phonecfg.phoneOS === "ANDROID") {
      if (parseInt(phonecfg.version.split(".")[2]) > 81) {
        GetGpsInfo();
      } else {
        socketManager(SocketCommand.GET_GPS_INFO, undefined);
      }
    } else if (phonecfg.phoneOS === "IOS") {
      if (parseInt(phonecfg.version.split(".")[2]) > 35) {
        GetGpsInfo();
      } else {
        socketManager(SocketCommand.GET_GPS_INFO, undefined);
      }
    }

    switch (typeIndex) {
      case 0:
        handleRequest254();
        setLoading(true);
        break;
      case 1:
        handleRequest255();
        setLoading(true);
        break;
      default:
        setPharmacyList([]);
        break;
    }
    // }
  }, [typeIndex]);

  const handleSubMenu = index => {
    setTypeIndex(index);
    if (index === 0) {
      userHabit(phonecfg, "PR011");
    } else if (index === 1) {
      userHabit(phonecfg, "PR012");
    } else {
      userHabit(phonecfg, "PR013");
    }
  };

  useEffect(() => {
    //닫기(취소, 확인)
    $(".receive-inquiry-layer .tbns-area a").click(function () {
      closeLayerFn($(".receive-inquiry-layer"));
    });

    // 지도 닫기
    $(".map-view-layer .btn-closex").click(function () {
      closeLayerFn($(".map-view-layer"));
    });

    // $(".map-view-layer .btn-backpage").click(function () {
    //     closeLayerFn($(".map-view-layer"));
    // });
  });

  useEffect(() => {
    userHabit(phonecfg, "PR010");
    NativeAction(phonecfg, "statusColor", "#b2bee6");

    // if(phonecfg.phoneOS === "IOS") {
    if (
      phonecfg.phoneOS === "IOS" &&
      parseInt(phonecfg.version.split(".")[2]) > 13
    ) {
      NativeAction(phonecfg, "inputEPmenu", "in");
    }
  }, [phonecfg.version]);

  useEffect(() => {
    if (checkMobile() === "ANDROID") {
      // window.java.rcvFromWeb("wn111");
    } else if (
      checkMobile() === "IOS" &&
      parseInt(phonecfg.version.split(".")[2]) >= 25
    ) {
      webkit.messageHandlers.rcvFromWeb.postMessage({
        command: "wn111",
        data: "wn111",
      });
    }
  }, []);

  // useEffect(() => {
  //   window.NativeInterface = {
  //     // itemState: value => {
  //     //   console.log("value ::: ", value);
  //     //   _O.Open("/eocs/history/1");
  //     // },

  //     webReload: value => {
  //       // reloadList();
  //       _O.Open("/eocs/history/1");
  //     },
  //   };
  // }, []);

  useEffect(() => {
    if (itemState.reload) {
      dispatch({
        type: SET_ITEMSTATE,
        data: { type: "COMPLETE" },
      });
      _O.Open("/eocs/history/1");
    }
  }, [itemState.reload]);

  return (
    <Fragment>
      <Container
        Title={type.label}
        /*bottom={list == null || list.length === 0 ? <Bottom /> : null}*/ goToUrl={
          "/"
        }>
        <div className="contents sub grad">
          <SubMenu SUBS={SUBS} code={sub.code} phoneOs={phonecfg.phoneOS} />

          <div className="sub-contents">
            {eocsList !== null && (
              <Eocs
                selectedEocsIndex={selectedEocsIndex}
                eocsList={eocsList}
                userToken={userinfo.userToken}
                reloadList={reloadList}
              />
            )}

            <TypeMenu
              TYPES={TYPES_RECEIPT}
              code={type.code}
              setTypeIndex={handleSubMenu}
            />

            {typeIndex === 2 ? (
              <PharmacySearchLayer
                handleSearchPharmacy={handleSearchPharmacy}
              />
            ) : null}

            {/* {(pharmacyList === null || pharmacyList.length === 0) && typeIndex === 0 && ( */}

            {loading ? (
              <Fragment>
                <SkeletonPharm />
              </Fragment>
            ) : (
              <Fragment>
                {pharmacyList != null && pharmacyList.length > 0 ? (
                  pharmacyList.map((m, i) => (
                    <Pharmacy
                      key={m.pharmacy[0].phKey}
                      m={m}
                      i={i}
                      typeIndex={typeIndex}
                      handleReceiptRequest={handleReceiptRequest}
                      handleRequest254={handleRequest254}
                      handleMaps={handleMaps}
                      setLocationInfo={setLocationInfo}
                    />
                  ))
                ) : (
                  <Fragment>
                    {pharmacyList != null &&
                      pharmacyList.length === 0 &&
                      typeIndex === 0 && <NothingMyPh />}
                    {pharmacyList != null &&
                      pharmacyList.length === 0 &&
                      typeIndex === 1 && <NothingNearByPh />}
                    {pharmacyList != null &&
                      pharmacyList.length === 0 &&
                      typeIndex === 2 && <NothingSearchPh />}
                  </Fragment>
                )}
              </Fragment>
            )}
          </div>
        </div>
      </Container>

      <DateLayer />
      <ReceiptConfirmLayer handleRequest201={handleRequest201} />
      <ReceiptCompleteLayer />
      <ReceiptRequestLayer handleRequest201={handleRequest201} />
      {/* <AlertDialogLayer title={dialog.title} msg={dialog.msg} /> */}
      <AlertLayer
        title={dialog.title}
        msg={dialog.msg}
        handleConfirmCB={
          dialog.handleConfirmCB === "certi"
            ? () => _O.OpenMenu("/membership/certification")
            : () => closeLayerFn(".alert-layer")
        }
      />

      <MapView locationInfo={locationInfo} popupType="PH" />
      {/* <MapView mapInfo={maps} /> */}

      {getCookie("isAuthOk") == 9 ? (
        <ConfirmLayer
          title={dialog.title}
          msg={dialog.msg}
          handleConfirmCB={() => _O.OpenMenu("/membership/certification")}
          handleCancelCB={() => closeLayerFn(".confirm-layer")}
        />
      ) : (
        <SendFaxLayer eocsInfo={eocsInfo} handleDialog={handleDialog} />
      )}
    </Fragment>
  );
};

const Eocs = memo(({ selectedEocsIndex, eocsList, userToken, reloadList }) => {
  const { phonecfg, userinfo } = useContext(AppContext);
  const eprescription = eocsList[selectedEocsIndex];

  const eocsUrl =
    eprescription.filePath !== null && eprescription.filePath.length > 0
      ? "ep://view" + "," + eprescription.filePath
      : eprescription.url !== null && eprescription.url.length > 0
      ? "ep://autodown" +
        "," +
        eprescription.url +
        "," +
        userToken +
        "," +
        eprescription.pxid +
        "," +
        eprescription.hospital[0].zipcode
      : null;

  const putJsonData = (
    downType,
    fileName,
    downLink,
    userToken,
    pxId,
    zipCode,
    viewYN,
    reserved
  ) => {
    // return {"downType":downType, "fileName":fileName, "downLink":downLink, "userToken":userToken, "pxId":pxId, "zipCode":zipCode}
    return {
      downType: downType,
      fileName: fileName,
      downLink: downLink,
      userToken: userToken,
      pxId: pxId,
      zipCode: zipCode,
      viewYN: viewYN,
      reserved: reserved,
    };
  };

  const socketConnection = (trsmId, paperFlag) => {
    let masterKey2 = "E";

    commonFileUpload(
      reloadList,
      userinfo,
      trsmId + "!" + masterKey2,
      1,
      "Y",
      "EP",
      "전자처방전",
      "10"
    );
  };

  const handleEocsView = (
    filePath,
    url,
    userToken,
    pxid,
    zipcode,
    viewYN,
    reserved
  ) => {
    try {
      // filePath !== null && filePath.length > 0
      //     ? socketManager(SocketCommand.PRSC_DNLD, reloadList, putJsonData('view', filePath, url, userToken, pxid, zipcode, viewYN, reserved))

      // : ( url !== null && url.length > 0
      //         ? socketManager(SocketCommand.PRSC_DNLD, reloadList, putJsonData('autodown', filePath, url, userToken, pxid, zipcode, viewYN, reserved))
      //         : handleDialog("", "처방전 관련 정보가 없습니다.", '')
      // )

      if (filePath !== null && filePath.length > 0) {
        socketConnection(pxid);
      } else {
        socketConnection(pxid);
      }
    } catch (e) {
      handleDialog("", "처방전 보기는 단말기에서만 동작됩니다.", "");
      return;
    }
  };

  return (
    <div className="pr-section">
      {/* <a href={eocsUrl === null ? void 0 : eocsUrl}> */}
      <a
        onClick={() =>
          handleEocsView(
            eprescription.filePath,
            eprescription.url,
            userToken,
            eprescription.pxid,
            eprescription.hospital[0].zipcode,
            "Y",
            ""
          )
        }>
        <div className="blue-box-area">
          <div className="tt-box">
            <div className="px-bx">
              <i></i>
              <span>전자처방전</span>
              <p>{eprescription.hospital[0].hpName}</p>
            </div>
            <div className="top-label">
              <span>
                <i></i>
                {Alergy(eprescription.allergyCheck)}
              </span>
            </div>
          </div>
          <div className="bb-box">
            교부번호. <em>{eprescription.hpGrantNum}</em>
            <u>{getDateFormat(eprescription.publishDate)}</u>
          </div>
        </div>
      </a>
    </div>
  );
});

export const SendFaxLayer = props => {
  const { eocsInfo, handleDialog } = props;
  const { userinfo, cfg } = useContext(AppContext);

  const handleConfirmCB = () => {
    if (!$("#agreement").is(":checked")) {
      handleDialog("", "전화번호 사용에 동의해주세요.", "");
      return;
    }

    if ($("#inputFaxNum").val() == "") {
      handleDialog("", "약국의 팩스번호를 입력해주세요.", "");
      return;
    }

    sendFaxModule(
      cfg.faxUrl,
      userinfo,
      eocsInfo.pxid,
      $("#inputFaxNum").val(),
      $("#inputPhKey").val()
    )
      .then(res => {
        if (res.resultCode === "SUCC") {
          // setEocsList(res.resultList);
          console.log("전송성공");
        } else {
          // setEocsList(null);
          console.log("전송실패", res);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleCancelCB = () => {
    closeLayerFn($(".confirm-layer"));
  };

  useEffect(() => {
    $(".confirm-layer .tbns-area a").click(function () {
      closeLayerFn($(".confirm-layer"));
    });
  });

  return (
    <div className="blacklayer-container confirm-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div className="blgrn-box vertical">
          <div className="blgr-title">처방전 팩스 보내기</div>

          <div className="save-question-box">
            <p>약국에 팩스로 처방전을 보냅니다.</p>
            <p>보내지는 처방전에 내 전화번호가 표시됩니다.</p>

            <div>
              <input type="checkbox" id="agreement" value="" />
              <label htmlFor="agreement">전화번호 사용에 동의합니다.</label>
            </div>
            <div>
              <input
                type="number"
                pattern="\d*"
                className="textbox"
                id="inputFaxNum"
                placeholder="팩스번호를 입력해주세요."
              />
              <input type="hidden" id="inputPhKey" />
            </div>
          </div>

          <div className="tbns-area">
            <a
              href={void 0}
              className="btn-round gray"
              onClick={handleCancelCB}>
              취소
            </a>
            <a
              href={void 0}
              className="btn-round wht"
              onClick={handleConfirmCB}>
              확인
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const PharmacySearchLayer = memo(({ handleSearchPharmacy }) => {
  const [inputs, setInputs] = useState({
    name: "",
    address: "",
  });

  const { name, address } = inputs;

  const handleChange = e => {
    const { name, address } = e.target;

    setInputs({
      ...inputs,
      [name]: e.target.value,
    });
  };

  const handleReset = () => {
    setInputs({
      name: "",
      address: "",
    });
  };

  const handleSearch = (name, address) => {
    handleReset();
    handleSearchPharmacy(name, address);
  };

  return (
    <div className="pharmacy-search">
      <div>
        <input
          type="text"
          name="name"
          className="textbox"
          value={name}
          onChange={handleChange}
          placeholder="약국명을 입력해주세요."
          onKeyUp={e => {
            if (window.event.keyCode == 13) {
              handleSearch(name, address);
            }
          }}
        />
        <a
          onClick={e => {
            handleSearch(name, address);
          }}></a>
      </div>
      <div>
        <input
          type="text"
          name="address"
          className="textbox"
          value={address}
          onChange={handleChange}
          placeholder="도로명 주소를 입력해주세요. "
          onKeyUp={e => {
            if (window.event.keyCode == 13) {
              handleSearch(name, address);
            }
          }}
        />
        <a
          onClick={e => {
            handleSearch(name, address);
          }}></a>
      </div>
    </div>
  );
});

const Pharmacy = memo(
  ({
    m,
    i,
    typeIndex,
    handleReceiptRequest,
    handleRequest254,
    handleMaps,
    setLocationInfo,
  }) => {
    const { userinfo, cfg, phonecfg } = useContext(AppContext);

    const pharmacy = m.pharmacy[0];
    const [myPhmarcy, setMyPharmacy] = useState(pharmacy.myph);

    const togleMyPharmacy = () => {
      setMyPharmacy(myPhmarcy === "1" ? "0" : "1");
    };

    const handleFavoritePharmacy = myPharmacy => {
      PostApi203(userinfo, cfg, phonecfg, pharmacy.phKey, myPharmacy)
        .then(res => {
          if (res.resultCode === "1" && res.resultMsg === "SUCCESS") {
            // TODO 해당 componen만 삭제하는 방법 확인 필요
            if (typeIndex === 0) handleRequest254();
            else togleMyPharmacy();
          } else {
            // this.handleResponse201(pxStatus, true)
          }
        })
        .catch(err => {
          console.log(err);
        });
    };

    const mapLayer = (name, lat, lon, locationInfo) => {
      if (name === null || lat === null || lon === null) return;

      handleMaps(name, lat, lon);
      setLocationInfo(locationInfo);

      NativeAction(phonecfg, "statusColor", "#FFFFFF");
      openLayerFn($(".map-view-layer"));
    };

    const openSendFax = (phKey, faxNum) => {
      $(".confirm-layer").show();

      $("#inputPhKey").val(phKey);
      $("#inputFaxNum").val(faxNum);
    };

    useEffect(() => {
      //닫기(취소, 확인)
      $(".receive-alert-layer .tbns-area a").click(function () {
        closeLayerFn($(".receive-alert-layer"));
      });
    }, []);

    return (
      <div className="linebox-info-list">
        <ul>
          <li>
            <div className="line-box">
              <div className="addr">
                <span>
                  {pharmacy.phName} {pharmacy.pxKey}
                </span>
                <p>
                  {pharmacy.address3} {pharmacy.address4}
                </p>
                <div className="heart-btn">
                  <a
                    href={void 0}
                    className={myPhmarcy === "1" ? "on" : ""}
                    onClick={e => {
                      handleFavoritePharmacy(myPhmarcy);
                    }}>
                    <i></i>
                  </a>
                </div>
              </div>
              <div className="thr-btns">
                <a
                  onClick={() =>
                    mapLayer(
                      pharmacy.phName,
                      pharmacy.latitude,
                      pharmacy.longitude,
                      pharmacy
                    )
                  }
                  className="location btn-open-map"></a>
                {pharmacy.pxReceipt === "1" && (
                  <a
                    href={void 0}
                    className="hf btn-open-receiveinquirylayer"
                    onClick={e => {
                      handleReceiptRequest(m.pharmacy[0].phKey, "2");
                    }}>
                    조제문의
                  </a>
                )}
                {pharmacy.pxReceipt === "1" && (
                  <a
                    href={void 0}
                    className="hf btn-open-receivelayer"
                    onClick={e => {
                      handleReceiptRequest(m.pharmacy[0].phKey, "1");
                    }}>
                    조제접수
                  </a>
                )}
                {pharmacy.pxReceipt === "0" && (
                  <a
                    href={void 0}
                    className="hf btn-open-receivelayer"
                    onClick={() => {
                      openSendFax(m.pharmacy[0].phKey, m.pharmacy[0].faxNum);
                    }}>
                    처방전 팩스 보내기
                  </a>
                )}
              </div>
            </div>
          </li>
        </ul>
      </div>
    );
  }
);

const Bottom = () => {
  return (
    <div className="under-fix-btnarea">
      <Link to="/sm/bp/input" className="btn-inputok">
        <i></i>입력
      </Link>
    </div>
  );
};

const NothingMyPh = (props) => {
  return (
    <div className="linebox-info-list">
      <div className="nodata">
        <img src={IC.empty.myPh} alt="" />
        <p>접수한 MY 약국이 없습니다.</p>
      </div>
    </div>
  );
};

const NothingNearByPh = (props) => {
  return (
    <div className="linebox-info-list">
      <div className="nodata">
        <img src={IC.empty.nearByPh} alt="" />
        <p>가까운 약국을 찾을 수 없습니다. </p>
      </div>
    </div>
  );
};

const NothingSearchPh = (props) => {
  return (
    <div className="linebox-info-list">
      <div className="nodata">
        <img src={IC.empty.searchPh} alt="" />
        <p>약국을 검색해 주세요.</p>
      </div>
    </div>
  );
};

const ReceiptConfirmLayer = ({ handleRequest201 }) => {
  return (
    <div className="blacklayer-container receive-alert-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div>
          <div className="blgrn-box vertical priv">
            <div className="blgr-title">조제 접수</div>

            <div className="save-question-box">조제접수 하겠습니까?</div>

            <div className="tbns-area">
              <a className="btn-round gray">취소</a>
              <a className="btn-round wht" onClick={e => handleRequest201()}>
                확인
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ReceiptCompleteLayer = (props) => {
  useEffect(() => {
    ////조제접수 하겠습니까? - 접수가 완료되었습니다.
    //닫기(확인)
    $(".receive-complete-layer .tbns-area a").click(function () {
      closeLayerFn($(".receive-complete-layer"));

      // 처방전기록 - 접수중 처방전 화면으로 이동
      _O.Open("/eocs/history/0");
    });
  });

  return (
    <div className="blacklayer-container receive-complete-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div>
          <div className="blgrn-box vertical priv">
            <div className="blgr-title">조제 접수</div>

            <div className="save-question-box">접수가 완료되었습니다</div>

            <div className="tbns-area">
              <a className="btn-round wht">확인</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ReceiptRequestLayer = ({ handleRequest201 }) => {
  return (
    <div className="blacklayer-container receive-inquiry-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div>
          <div className="blgrn-box vertical priv">
            <div className="blgr-title">조제 접수</div>

            <div className="save-question-box">
              <span className="utt">약국에 조제가능 여부를 문의합니다.</span>
              조제가능 확인 후 조제접수 해주세요.
            </div>

            <div className="tbns-area">
              <a className="btn-round gray">취소</a>
              <a className="btn-round wht" onClick={e => handleRequest201()}>
                확인
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const getDateFormat = (dateStr) => {
  if (dateStr.length !== 8) return dateStr;

  return dateStr.length != 0 && dateStr.length == 8
    ? dateStr.substring(0, 4) + "." + dateStr.substring(4, 6) + "." + dateStr.substring(6, 8)
    : "";
};

const Alergy = (type) => {
  switch (type) {
    case "-1":
      return "체크안함";
    case "0":
      return "알레르기 위험";
    case "1":
      return "알레르기 안전";
    case "2":
      return "알레르기 임산부 위험";
    case "3":
      return "알레르기 임산부 주의";
    case "4":
      return "알레르기 임산부 안전";
    default:
      return "";
  }
};
